import { Box } from "@bca/ui-library";
import { FunctionComponent, useContext } from "react";
import { ThemeContext } from "styled-components";
import { StyledIconProps } from "./StyledIcon.type";

const ExclamationCircleBoldSVG: FunctionComponent<StyledIconProps> = ({
  fill = "primary-red",
  ...props
}) => {
  const theme = useContext(ThemeContext);
  const color = theme.colors[fill] || fill;

  return (
    <Box {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="100%"
        width="100%"
        viewBox="0 0 25 24"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.1484 6.41608L10.4779 12.9967C10.4934 13.3058 10.7489 13.5484 11.0587 13.5484H13.054C13.3639 13.5484 13.6193 13.3058 13.6348 12.9967L13.9643 6.41608C13.9809 6.08443 13.7161 5.80645 13.3835 5.80645H10.7292C10.3966 5.80645 10.1318 6.08443 10.1484 6.41608ZM14.0918 16.6452C14.0918 17.7658 13.1787 18.6774 12.0563 18.6774C10.934 18.6774 10.0209 17.7658 10.0209 16.6452C10.0209 15.5246 10.934 14.6129 12.0563 14.6129C13.1787 14.6129 14.0918 15.5246 14.0918 16.6452ZM12.0563 21.6774C6.69967 21.6774 2.36381 17.3501 2.36381 12C2.36381 6.65346 6.69986 2.32258 12.0563 2.32258C17.411 2.32258 21.7489 6.65182 21.7489 12C21.7489 17.3482 17.4148 21.6774 12.0563 21.6774ZM12.0563 0C5.41904 0 0.0375977 5.37498 0.0375977 12C0.0375977 18.6289 5.41904 24 12.0563 24C18.6937 24 24.0751 18.6289 24.0751 12C24.0751 5.37498 18.6937 0 12.0563 0Z"
          fill={color}
        />
      </svg>
    </Box>
  );
};

export default ExclamationCircleBoldSVG;
